import { jsxs as L, jsx as l } from "react/jsx-runtime";
import { forwardRef as uo, useState as s, useRef as U, useEffect as V } from "react";
import mo from "react-input-mask";
import m from "classnames";
import _o from "../FieldContainer/index.js";
import ao from "../../helpers/nanoid.js";
import fo from "../../helpers/setNativeInputValue.js";
const lo = "forma-ui__phone-input__input", ho = "forma-ui__phone-input__open", Io = "forma-ui__phone-input__position-top", wo = "forma-ui__phone-input__position-bottom", So = "forma-ui__phone-input__withIcon", yo = "forma-ui__phone-input__readonly", go = "forma-ui__phone-input__secondary", Ro = "forma-ui__phone-input__inputIcon", To = "forma-ui__phone-input__codes", No = "forma-ui__phone-input__codesItem", Co = "forma-ui__phone-input__codesItemIcon", e = {
  input: lo,
  open: ho,
  "position-top": "forma-ui__phone-input__position-top",
  positionTop: Io,
  "position-bottom": "forma-ui__phone-input__position-bottom",
  positionBottom: wo,
  withIcon: So,
  readonly: yo,
  secondary: go,
  inputIcon: Ro,
  codes: To,
  codesItem: No,
  codesItemIcon: Co
}, bo = 300, Lo = uo(({
  id: c = ao(8),
  name: D,
  onChange: W,
  onFocus: w,
  onBlur: S,
  hidden: v,
  fullWidth: z,
  label: A,
  className: G,
  readOnly: y,
  viewStyle: J = "primary",
  showIconAlways: K,
  maxLength: Bo = 50,
  containerClass: O,
  labelClass: Q,
  error: g,
  errorMessage: X,
  success: Y,
  icon: R,
  buttons: T,
  showClearButton: h,
  tooltip: d,
  tooltipClass: Z,
  notice: M,
  placeholder: k,
  masks: _,
  defaultMaskCode: r,
  onChangeMask: N,
  required: oo,
  value: p,
  ...to
}, no) => {
  var q;
  const [a, C] = s(!1), [eo, io] = s(!1), [f, I] = s(!1), [b, B] = s("bottom"), F = p && ((q = _.find(({ code: o }) => {
    var n;
    const t = (n = p.match(/([0-9]+)[-|\(]/)) == null ? void 0 : n[1];
    return !!(t && o === "+" + t || p.replace("+", "").startsWith(o.replace("+", "")));
  })) == null ? void 0 : q.iso), [x, $] = s(F ?? r), [E, H] = s(!1), P = U(null), j = U(E);
  j.current = E, V(() => {
    r && !F && r !== x && $(r);
  }, [r]), V(() => {
    const o = P.current;
    if (!f || !o)
      return;
    const t = o.getBoundingClientRect(), n = o == null ? void 0 : o.closest(".modal__content"), u = (n == null ? void 0 : n.offsetHeight) ?? window.innerHeight;
    t.height > u - t.top - t.height ? B("top") : B("bottom");
  }, [f]);
  const so = (o) => {
    w && w(o), H(!0), C(!0);
  }, co = (o) => {
    S && S(o), H(!1), setTimeout(() => {
      j.current || (C(!1), I(!1), d && io(!1));
    }, bo);
  }, ro = (o) => {
    if ($(o), N) {
      const n = _.find(({ iso: u }) => u === o);
      n && N(n);
    }
    I(!1), fo(c, "");
    const t = document.querySelector('input[id="' + c + '"]');
    t && setTimeout(() => {
      t.selectionStart = t.selectionEnd = 1e4;
    }, 0);
  }, po = () => {
    const o = document.querySelector('input[id="' + c + '"]');
    o == null || o.focus(), I((t) => !t);
  }, i = _.find(({ iso: o }) => o === x);
  return /* @__PURE__ */ L(
    _o,
    {
      id: c,
      hidden: v,
      required: oo,
      fullWidth: z,
      containerClass: O,
      labelClass: Q,
      label: A,
      error: g,
      errorMessage: X,
      showClearButton: h,
      notice: M,
      buttons: T,
      icon: R,
      tooltip: d,
      tooltipClass: Z,
      isShowClear: a && h && !!p,
      isShowButtons: a,
      isShowTooltip: eo,
      isShowIcon: a || K,
      children: [
        /* @__PURE__ */ l("img", { className: m(e.inputIcon, "country-icon"), src: i == null ? void 0 : i.flag, alt: i == null ? void 0 : i.name, onClick: po }),
        /* @__PURE__ */ l(
          mo,
          {
            ...to,
            id: c,
            name: D,
            inputMode: "tel",
            placeholder: a ? void 0 : k,
            onChange: W,
            onFocus: so,
            onBlur: co,
            className: m(
              e.input,
              e[J],
              e[`position-${b}`],
              f && e.open,
              G,
              g && "error",
              Y && "success",
              (R || T || d || h) && e.withIcon,
              y && e.readonly
            ),
            value: p,
            readOnly: y,
            inputRef: no,
            mask: i ? `${i.code}${i.mask}` : "",
            maskChar: null,
            formatChars: { "#": "[0-9]" }
          }
        ),
        f && /* @__PURE__ */ l("div", { className: m(e.codes, e[`position-${b}`], "input-phone-codes", "styled-scrollbar"), ref: P, children: _.map(({ iso: o, code: t, name: n, flag: u }) => /* @__PURE__ */ L("div", { className: m(e.codesItem, "input-phone-codes__item"), onMouseDown: () => ro(o), children: [
          /* @__PURE__ */ l("img", { className: m(e.codesItemIcon, "input-phone-codes__icon"), src: u, alt: n }),
          " ",
          t,
          " ",
          n
        ] }, o)) })
      ]
    }
  );
});
export {
  Lo as default
};
